import { motion } from 'framer-motion'
import { List } from '@phosphor-icons/react'

interface HeaderActionsProps {
  onMenuClick: () => void
}

export function HeaderActions({ onMenuClick }: HeaderActionsProps) {
  return (
    <div className="flex items-center gap-1">
      <motion.button
        className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
        whileTap={{ scale: 0.95 }}
        onClick={onMenuClick}
        aria-label="Open menu"
      >
        <List size={22} className="text-gray-700" weight="bold" />
      </motion.button>
    </div>
  )
}
